var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: { content: "Configuración de Secciones", "has-line": "" }
      }),
      _c(
        "div",
        { staticClass: "my-4" },
        [
          _c("validation-observer", { ref: "sectionValidator" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 col-lg-8" }, [
                _c("div", {}, [
                  _c(
                    "div",
                    { staticClass: "row d-flex align-items-end" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-4" },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("b", [_vm._v("Nombre de la Sección:")]),
                                    _c("custom-drop-down", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido",
                                        disabled: _vm.isDragAndDropEnable,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        options: _vm.availableSections,
                                        placeholder: "Seleccione"
                                      },
                                      model: {
                                        value: _vm.model.section,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "section", $$v)
                                        },
                                        expression: "model.section"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _vm.isOther
                        ? _c(
                            "div",
                            { staticClass: "col-12 col-md-3 pl-0" },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-input", {
                                            staticClass: "mt-2",
                                            attrs: {
                                              "custom-error-msg":
                                                "El campo es requerido",
                                              error: errors[0],
                                              maxlength: "3000",
                                              placeholder: "Escriba una Sección"
                                            },
                                            model: {
                                              value: _vm.model.other,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "other",
                                                  $$v
                                                )
                                              },
                                              expression: "model.other"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1038699656
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("action-button", {
                        attrs: {
                          disabled: _vm.isDragAndDropEnable,
                          i: "fas fa-file-plus",
                          text: "Añadir Sección",
                          variant: "success col-12 col-md-2 px-0"
                        },
                        on: {
                          click: function($event) {
                            return _vm.add()
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "col-12 col-lg-4" }, [
                _vm.input.length
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-content-lg-end mt-lg-4" },
                      [
                        _c(
                          "div",
                          { staticClass: "mr-1" },
                          [
                            _c("action-button", {
                              class: _vm.isDragAndDropEnable
                                ? "custom-reorganize-btn text-white"
                                : "outline-dark-gray",
                              attrs: {
                                i: "far fa-sort-alt",
                                text: _vm.isDragAndDropEnable
                                  ? "Finalizar Reorganización"
                                  : "Reorganizar Secciones"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.reorganize()
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mx-1" },
                          [
                            _c("action-button", {
                              staticClass: "outline-dark-gray",
                              attrs: {
                                disabled: _vm.isDragAndDropEnable,
                                i: _vm.allExpanded
                                  ? "fal fa-compress-arrows-alt"
                                  : "fal fa-expand-alt",
                                text: _vm.allExpanded
                                  ? "Colapsar Todo"
                                  : "Expandir Todo"
                              },
                              on: { click: _vm.toggleExpandCollapse }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ])
        ],
        1
      ),
      _vm.input.length
        ? _c("section-title", {
            attrs: { content: "Secciones", "has-line": "" }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "custom-collapse",
            { attrs: { id: "question-sections-collapse" } },
            [
              _c(
                "draggable",
                {
                  attrs: {
                    disabled: !_vm.isDragAndDropEnable,
                    "force-fallback": "",
                    "ghost-class": "ghost",
                    list: _vm.input
                  },
                  on: {
                    end: function($event) {
                      _vm.dragging = false
                    },
                    start: function($event) {
                      _vm.dragging = true
                    }
                  }
                },
                _vm._l(_vm.input, function(item, key) {
                  return _c(
                    "custom-collapse-item",
                    {
                      key: `section-collapse-item-${key + 1}`,
                      ref: `section-collapse-item-${key + 1}`,
                      refInFor: true,
                      staticClass: "my-3 collapse-item section bg-gray",
                      class: { "rounded invalid": item.valid === false },
                      attrs: {
                        id: `section-collapse-item-${key + 1}`,
                        "auto-expand-collapse-enabled": false,
                        "button-icon": "far fa-times-circle color-red",
                        disabled: _vm.isReadOnly || _vm.isDragAndDropEnable,
                        expanded: item.expanded,
                        "expanded-icon":
                          "fas fa-plus-circle custom-reorganize-btn",
                        "icon-class-when-button-disabled":
                          "fas fa-grip-vertical flex-fill d-flex justify-content-end align-items-center",
                        "keep-btn-visible": false,
                        "parent-id": "question-sections-collapse",
                        "read-only-icon": "fas fa-plus-circle color-gray-2",
                        "show-icon-when-button-disabled":
                          _vm.isDragAndDropEnable,
                        title: item.name
                      },
                      on: {
                        actionButtonClick: function($event) {
                          return _vm.quit(item, key)
                        },
                        expandButtonClick: function($event) {
                          return _vm.expand(item, key)
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title-left",
                            fn: function() {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "title-number-box rounded ml-2 p-1 text-white"
                                  },
                                  [_vm._v(" " + _vm._s(key + 1) + " ")]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "section-title col-6" }, [
                          _c("div", { staticClass: "d-inline mr-2 bg-white" }, [
                            _c("i", {
                              staticClass: "fas fa-list text-orange fa-lg"
                            })
                          ]),
                          _c(
                            "span",
                            {
                              staticClass:
                                "color-gray-7 font-16 font-weight-bold"
                            },
                            [_vm._v(" Información de Sección ")]
                          )
                        ]),
                        item.id !== _vm.sectionTypes.LOCALITY
                          ? _c(
                              "div",
                              {
                                staticClass: "col-6 d-flex justify-content-end"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "mr-2" },
                                  [
                                    _c("action-button", {
                                      class: _vm.questionsDragEnabled(key)
                                        ? "custom-reorganize-btn text-white"
                                        : "outline-dark-gray",
                                      attrs: {
                                        disabled:
                                          _vm.isReadOnly ||
                                          _vm.isDragAndDropEnable,
                                        i: "far fa-sort-alt",
                                        text: _vm.questionsDragEnabled(key)
                                          ? "Finalizar Reorganización"
                                          : "Reorganizar Preguntas"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.reorganizeQuestions(key)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mx-1" },
                                  [
                                    _c("action-button", {
                                      staticClass: "outline-dark-gray",
                                      attrs: {
                                        disabled:
                                          _vm.isReadOnly ||
                                          _vm.isDragAndDropEnable ||
                                          _vm.questionsDragEnabled(key),
                                        i: _vm.questionsAllExpanded(key)
                                          ? "fal fa-compress-arrows-alt"
                                          : "fal fa-expand-alt",
                                        text: _vm.questionsAllExpanded(key)
                                          ? "Colapsar Todo"
                                          : "Expandir Todo"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleQuestionsExpandCollapse(
                                            key
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _c("questions", {
                        ref: `section-${key}`,
                        refInFor: true,
                        attrs: {
                          input: item.questions,
                          "is-locality": item.id === _vm.sectionTypes.LOCALITY,
                          "is-read-only":
                            _vm.isReadOnly || _vm.isDragAndDropEnable
                        },
                        on: {
                          "update:input": function($event) {
                            return _vm.$set(item, "questions", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }